import {EventEmitter, Injectable} from '@angular/core';
import { FaultCount } from "@docma-mm-core/fault/fault-counts";
import {BehaviorSubject, filter, first, map, Subject} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@Injectable()
@UntilDestroy()
export class MmFaultsCountService {

  private deletedFaultsCount = 0;
  private newFaultsCount = 0;
  private newFaultsForTotalCount = 0;
  private allFaultsCountSubject = new BehaviorSubject<FaultCount>(new FaultCount());

  deletedFaultsSubject = new BehaviorSubject<any>(null);
  newFaultsSubject = new BehaviorSubject<any>(null);
  deletedFaults$ = this.deletedFaultsSubject.asObservable();
  newFaults$ = this.newFaultsSubject.asObservable();
  allFaultsCount$ = this.allFaultsCountSubject.asObservable();

  public allFaultsCount() {
    return this.allFaultsCountSubject.value;
  }

  public get deletedFaults() {
    return this.deletedFaultsCount;
  }

  public get newFaults() {
    return this.newFaultsCount;
  }

  public get newFaultsForTotal() {
    return this.newFaultsForTotalCount;
  }

  constructor() { }

  setAllFaultsCount(faultCount: FaultCount) {
    this.allFaultsCountSubject.next(faultCount);
  }

  async addDeletedFaults(deletedCount: number) {
    this.deletedFaultsCount = (this.deletedFaultsCount + deletedCount);
    this.deletedFaultsSubject.next(null);
  }

  removeDeletedFaults(emit: boolean = true) {
    this.deletedFaultsCount = 0;
    if (emit) {
      this.deletedFaultsSubject.next(null);
    }
  }

  async addNewFaults(addedCount: number) {
    this.newFaultsCount += addedCount;
    this.newFaultsForTotalCount += addedCount;
    this.newFaultsSubject.next(null);
  }

  async removeNewFaults(countRemove?: number, emit: boolean = true) {
    if (!countRemove) {
      this.newFaultsCount = 0;
      this.newFaultsForTotalCount = 0;
      if (emit) {
        this.newFaultsSubject.next(null);
      }
    } else {
      this.newFaultsCount = Math.max(0, this.newFaultsCount - countRemove);
      this.newFaultsForTotalCount = Math.max(0, this.newFaultsForTotalCount - countRemove);
      if (emit) {
        this.newFaultsSubject.next(null);
      }
    }
  }

  decreaseVisibleNewFaults(countRemove: number) {
    this.newFaultsCount = Math.max(0, this.newFaultsCount - countRemove);
    this.newFaultsSubject.next(null);
  }
}
